import { motion } from 'motion/react';
import { usePrefersReducedMotion } from '../hooks/use-reduced-motion';

interface TallyLoaderProps {
  readonly label: string;
  readonly className?: string;
}

const STROKES = [0, 1, 2, 3] as const;

export function TallyLoader({ label, className = '' }: TallyLoaderProps) {
  const reduced = usePrefersReducedMotion();

  return (
    <div role="status" aria-live="polite" className={`flex items-center gap-3 text-muted ${className}`}>
      <svg width="34" height="24" viewBox="0 0 34 24" aria-hidden="true" className="text-ink">
        {STROKES.map((i) => (
          <motion.line
            key={i}
            x1={4 + i * 7}
            x2={4 + i * 7}
            y1={3}
            y2={21}
            stroke="currentColor"
            strokeWidth={2.2}
            strokeLinecap="round"
            initial={{ pathLength: reduced ? 1 : 0 }}
            animate={{ pathLength: 1 }}
            transition={
              reduced
                ? { duration: 0 }
                : { duration: 0.22, delay: i * 0.18, repeat: Infinity, repeatDelay: 1.1 }
            }
          />
        ))}
        <motion.line
          x1={1}
          x2={31}
          y1={18}
          y2={6}
          stroke="var(--brass)"
          strokeWidth={2.2}
          strokeLinecap="round"
          initial={{ pathLength: reduced ? 1 : 0 }}
          animate={{ pathLength: 1 }}
          transition={
            reduced ? { duration: 0 } : { duration: 0.3, delay: 0.75, repeat: Infinity, repeatDelay: 0.98 }
          }
        />
      </svg>
      <span className="text-sm">{label}</span>
    </div>
  );
}
